import { Spinner } from "@dit/core-frontend"
import { BlockWithAlignableContents } from "@lexical/react/LexicalBlockWithAlignableContents"
import { Box } from "@mos-cat/ds"
import React from "react"

const FigmaComponent = ({ className, format, nodeKey, url, documentID }) => {
  const [loading, setLoading] = React.useState(true)
  const defaultUrl = "https://www.figma.com/embed?embed_host=wiki&url="

  const handleLoad = () => {
    setLoading(false)
  }

  return (
    <BlockWithAlignableContents className={className} format={format} nodeKey={nodeKey}>
      {loading && (
        <Box width="560px" height="315px" position="relative" minHeight="25px">
          <Spinner space="sp-16" wrapper="div" />
        </Box>
      )}
      <iframe
        width={loading ? "0" : "560"}
        height={loading ? "0" : "315"}
        onLoad={handleLoad}
        src={
          url
            ? `${defaultUrl}\
            ${url}`
            : `${defaultUrl}\
            https://www.figma.com/file/${documentID}`
        }
        allowFullScreen={true}
      />
    </BlockWithAlignableContents>
  )
}

export default FigmaComponent
